<template>
  <section class="constituent-panel">
    <TitleHeader :title="title" />
    <div ref="scroll" class="constituent-body" @scroll="loadNext" v-loading="loading" element-loading-background="var(--theme-bg)">
      <table>
        <thead><tr><th>名称</th><th>最新价</th><th>涨跌幅</th></tr></thead>
        <tbody>
          <tr v-for="item in sharedStockRows(stocks, 'us')" :key="item.full_code" tabindex="0" @click="$emit('select-stock', item)" @keydown.enter="$emit('select-stock', item)">
            <td :title="item.prod_name"><button type="button" @click.stop="$emit('select-stock', item)">{{ item.prod_name }}</button></td>
            <td>{{ price(item.last_px) }}</td>
            <td :class="Number(item.px_change_rate) < 0 ? 'fall' : Number(item.px_change_rate) > 0 ? 'rise' : ''">{{ percent(item.px_change_rate) }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="error" class="list-state" role="alert">{{ error }} <button type="button" @click="load(errorPage, errorPage > page)">重试</button></div>
      <div v-else-if="!loading && !stocks.length" class="list-state">暂无成分股数据</div>
      <div v-if="refreshing && stocks.length && pendingPage > page" class="more-loading" v-loading="true" element-loading-background="var(--theme-bg)"></div>
    </div>
  </section>
</template>
<script>
import { quotePrice } from '@/utils/quoteDisplay'
import { quotePercent } from '@/utils/quoteDisplay'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
import TitleHeader from '../../home/components/titleHeader.vue'
import { getUSConstituents } from '@/utils/usQuotes'
import { pollMarket } from '@/utils/marketRefresh'
import { getStockQuotes } from '@/utils/stockQuotes'

export default {
  name: 'USConstituentPanel',
  components: { TitleHeader },
  props: { index: { type: String, required: true }, title: { type: String, required: true }, active: { type: Boolean, default: true } },
  data: () => ({ stocks: [], page: 0, total: 0, ended: false, pendingPage: 1, errorPage: 1, loading: false, refreshing: false, error: '', requestId: 0, timer: null }),
  watch: { active(value) { if (value) this.activate(); else this.stopPolling() } },
  mounted() { if (this.active) this.activate() },
  beforeDestroy() { this.disposed = true; this.requestId++; this.stopPolling() },
  methods: {
    price: quotePrice,
    sharedStockRows,
    stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
    async activate() {
      if (this.disposed || !this.active || this.stopRefresh) return
      try { if (this.page && this.stocks.length) await this.refreshPages(); else await this.load(1) }
      catch (_) { /* Keep the constituent snapshot on quote failure. */ }
      finally {
        if (!this.disposed && this.active && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.refreshPages(), 'us')
      }
    },
    async refreshPages() {
      if (this.disposed || !this.active || this.refreshing || !this.page) return
      const requestId = ++this.requestId; this.refreshing = true
      try {
        const rows = this.stocks
        if (!rows.length) return
        const quotes = await getStockQuotes(rows.map(item => item.full_code).join(','))
        if (requestId !== this.requestId) return
        this.stocks = this.stocks.map(item => {
          const quote = quotes[item.full_code]
          return Array.isArray(quote) && Number(quote[3]) > 0 ? { ...item, last_px: quote[3], px_change_rate: quote[32] } : item
        })
      } finally { if (requestId === this.requestId) this.refreshing = false }
    },
    percent: quotePercent,
    loadNext() {
      const scroll = this.$refs.scroll
      if (this.disposed || !this.active || !scroll || scroll.clientHeight <= 0 || this.refreshing || this.error || this.ended || this.page * 20 >= this.total) return
      if (scroll.scrollHeight - scroll.scrollTop - scroll.clientHeight <= 64) this.load(this.page + 1, true)
    },
    async load(page, append = false) {
      if (this.disposed || !this.active || this.refreshing) return
      const requestId = ++this.requestId
      this.refreshing = true; this.pendingPage = page
      this.loading = !this.stocks.length; this.error = ''
      try {
        const result = await getUSConstituents(this.index, page)
        if (requestId !== this.requestId) return
        const updates = new Map(result.stocks.map(item => [item.full_code, item]))
        if (!this.stocks.length) this.stocks = result.stocks
        else if (append) this.stocks = [...new Map([...this.stocks, ...result.stocks].map(item => [item.full_code, item])).values()]
        else this.stocks = this.stocks.map(item => updates.get(item.full_code) || item)
        this.total = result.total; this.page = page
        this.ended = result.stocks.length < 20 || page * 20 >= result.total
      } catch (_) {
        if (requestId === this.requestId) { this.error = '成分股加载失败，请重试。'; this.errorPage = page }
      } finally {
        if (requestId === this.requestId) { this.loading = false; this.refreshing = false }
        if (requestId === this.requestId && !this.error) this.$nextTick(this.loadNext)
      }
    }
  }
}
</script>
<style scoped>
.constituent-panel { min-width: 0; min-height: 0; display: flex; flex-direction: column; background: var(--theme-bg); color: var(--theme-label); }
.constituent-body { flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; }
table { width: 100%; table-layout: fixed; border-collapse: collapse; text-align: center; }
th, td { height: 31px; padding: 0 8px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: normal; }
th { position: sticky; top: 0; background: var(--theme-bg); z-index: 1; }
button { background: transparent; color: inherit; font: inherit; cursor: pointer; }
td button { width: 100%; padding: 0; border: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
tbody tr { cursor: pointer; } tbody tr:hover { background: var(--theme-header); }
.more-loading { height: 48px; position: relative; }
.rise { color: var(--quote-up); } .fall { color: var(--quote-down); }
.list-state { padding: 20px 4px; text-align: center; }
</style>
